export default __webpack_public_path__ + "static/media/ci3.0b7fd8b1.png";